import axios, { AxiosResponse } from 'axios';

export const url = '/services/isnaportalsync/open-api/global/find-document-confirming-residence';
//?clientRecaptchaResponse=${token}
export const getDocument = (request: any, token?: any): Promise<AxiosResponse> => {
    return axios.post<Blob>(`${url}`, request, { responseType: 'arraybuffer' });
};
